/** Meta pixel "pixel scout leader ready" (stockdigital.com).
 *  PageView on load, ViewContent when the offer section is seen, InitiateCheckout ONLY on the offer button. */
export const META_PIXEL_ID = '1158908550136183';
